module.exports = async function auth() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json ");

    var requestOptions = {
        method: 'POST',
        body: JSON.stringify({
            "email": "neotix@neotix.com.br",
            "password": "123"
        }),
        headers: myHeaders,
    };

    try {
        var fetchServer = await fetch("http://localhost:4040/thank-you-me/api/auth", requestOptions);

        var token = await fetchServer.json();
        return token.token
    } catch (error) {
        console.log('error', error)
    }
}
